<template>
    <v-autocomplete
        :value="value"
        :items="filterTimezoneList('America', timezoneList)"
        item-value="timezone"
        item-text="text"
        :rules="rules"
        :prepend-icon="smallPrepend ? '' : 'fas fa-globe'"
        :label="hideLabel ? '' : '* ' + $t('base.timezone')"
        :dark="dark"
        :hide-details="hideDetails"
        :disabled="disabled"
        @change="updateTimezone"
    >
        <template v-if="smallPrepend" slot="prepend">
            <v-icon small class="pt-2">
                fas fa-globe
            </v-icon>
        </template>
        <template
            slot-scope="{item}"
            slot="selection"
        >
            <template>
                <span class="pt-1">
                    {{ item.timezone.replace(/_/g, ' ') }} <span class="body-1">
                        &nbsp;({{ item.utcOffset }})
                    </span>
                </span>
            </template>
        </template>
        <template
            slot-scope="{item}"
            slot="item"
        >
            <span class="pt-1">
                {{ item.timezone.replace(/_/g, ' ') }} <span class="body-1">
                    &nbsp;({{ item.utcOffset }})
                </span>
            </span>
        </template>
    </v-autocomplete>
</template>
<script>
import { timezones } from '@/timezones';

export default {
    name: 'timezone-autocomplete',
    props: {
        value: { type: String, required: false },
        rules: { type: Array, required: false, default: () => [] },
        dark: { type: Boolean, required: false, default: false },
        hideLabel: { type: Boolean, required: false, default: false },
        hideDetails: { type: Boolean, required: false, default: false },
        smallPrepend: { type: Boolean, required: false, default: false },
        disabled: { type: Boolean, required: false, default: false },
    },
    mixins: [timezones],
    methods: {
        updateTimezone(value) {
            if (this.isTimezoneValid(value)) {
                this.$emit('update:value', value);
            }
        },
    },
};
</script>
